import Terms from "components/Terms";

export default Terms;



// WEBPACK FOOTER //
// ./src/containers/Terms/index.js